// extracted by mini-css-extract-plugin
export var active = "pill-switcher-module--active--cRy7g";
export var button = "pill-switcher-module--button--h+Naz";
export var pillContainer = "pill-switcher-module--pill-container--HjEe6";
export var pillInnerContainer = "pill-switcher-module--pill-inner-container--h48eQ";
export var pillOuterContainer = "pill-switcher-module--pill-outer-container--Dd9xv";
export var pillSwitcher = "pill-switcher-module--pill-switcher--2cqax";
export var slider = "pill-switcher-module--slider--Pfl5u";
export var small = "pill-switcher-module--small--LUyTs";
export var title = "pill-switcher-module--title--Rn2T9";